import axios from '../../../axios/index.js'
import store from '../../../../store/store.js'


// Token Refresh
let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched (access_token) {
  subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

export default {
  init () {
    axios.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      // const { config, response: { status } } = error
      const { config, response } = error
      const originalRequest = config

      // if (status === 401) {
      if (response && response.status === 401) {
          window.location.replace("/login");
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('auth/fetchAccessToken')
            .then((access_token) => {
              isAlreadyFetchingAccessToken = false
              onAccessTokenFetched(access_token)
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
      return Promise.reject(error)
    })
  },
  login (email, pwd) {
      let isLocalhost = window.location.href.indexOf("localhost");
      let apiEndpoint = '';
      if(isLocalhost>=0) {
          //apiEndpoint = 'https://demo.intelliprice.test/api/';
          //apiEndpoint = 'https://homemarkt.intelliprice.io/api/';
          apiEndpoint = 'https://squareshop.intelliprice.io/api/'
          //apiEndpoint = 'https://baklatsidis.intelliprice.io/api/'
          //apiEndpoint = 'https://demo24.intelliprice.io/api/'
      } else {
          apiEndpoint = "/../../api/"; // FOR LIVE
      }


    localStorage.setItem('apiEndpoint', apiEndpoint);

    return axios.post( apiEndpoint + 'login', {
      username: email,
      password: pwd
    })
  },
  refreshToken () {
    return axios.post('/api/refresh-token', {accessToken: localStorage.getItem('accessToKen')})
  }
}
